import { render, staticRenderFns } from "./DocumentStatusEditInPlace.vue?vue&type=template&id=6247c14a&scoped=true&"
import script from "./DocumentStatusEditInPlace.vue?vue&type=script&lang=js&"
export * from "./DocumentStatusEditInPlace.vue?vue&type=script&lang=js&"
import style0 from "./DocumentStatusEditInPlace.vue?vue&type=style&index=0&id=6247c14a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6247c14a",
  null
  
)

export default component.exports